import "./ComponentStyles/PersonInfoBox.css";
import PropTypes from 'prop-types';
import { useEffect } from "react";

function PersonInfoBox(props) {

    const role = props.role.toLowerCase();

    useEffect(() => {
        async function fetchText() {
          const response = await fetch(`${process.env.PUBLIC_URL}/about-data/${role}.txt`);
          const text = await response.text();
          const lines = text.split("\n");
          document.getElementById(`name-${role}`).innerHTML = `${lines[0]} - ${props.role}`;
          document.getElementById(`information-${role}`).innerHTML = lines[1];
        }
    
        fetchText();
      }, [props.role, role]);

    const orientation = props.orientation === "right" ? "right" : "left";

    return (
        <div id="info-container" className={orientation}>
            {
                orientation === "right" ?  (
                    <>
                        <div id="text-container">
                            <h1 id={`name-${role}`}>Name</h1>
                            <h2 id={`information-${role}`}>Role</h2>
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/about-data/${role}.png`} alt="executive board member" height={512} width={341}/>
                    </>
                ):(
                    <>
                        <img src={`${process.env.PUBLIC_URL}/about-data/${role}.png`} alt="executive board member" height={512} width={341}/>
                        <div id="text-container">
                            <h1 id={`name-${role}`}>Name</h1>
                            <h2 id={`information-${role}`}>Role</h2>
                        </div>
                    </>
                )
            }
        </div>
    );
}

PersonInfoBox.propTypes = {
    orientation: PropTypes.string.isRequired,
};

export default PersonInfoBox;